import { FundsGrid } from './FundsGrid.js';

/**
 * The CRM: the tracked funds. The funds nobody has chosen to track live on the
 * Discover page, in the same grid.
 */
export function FundsPage(): React.JSX.Element {
  return (
    <div className="page">
      <FundsGrid scope="list" />
    </div>
  );
}
